import { rgba } from 'polished';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

interface CustomElement extends PalletteProps {
  isSelected: boolean;
}

export const DateWrapper = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: .5rem;
  border-radius: 8px;
  border: ${({ theme, isSelected }: CustomElement) =>
    isSelected ? `solid 1px ${(theme.successColor)}` : `1px dashed ${(theme.gray4)}`};
  background: ${({ isSelected, theme, disabled }) => 
      disabled ? theme.lightGray : (isSelected ? rgba(theme.successColor, 0.15) : '')};
  padding: 10px 20px;
  transition: all 0.3s ease-in-out, color 0.3s ease-in-out;
  &:hover {
    cursor: pointer;
  }
`;

const BaseMonthAndDayText = styled.span<{ isSelected: boolean }>`
  font-size: 1rem;
  color: ${({ isSelected, theme }: CustomElement) =>
    isSelected ? theme.gray2 : theme.gray3};
`;

export const MonthText = styled(BaseMonthAndDayText)`
  font-size: .75rem;
`;
export const DayText = styled(BaseMonthAndDayText)``;
